module.exports = __webpack_public_path__ + "img/2_6_1.984da85a.jpg";